import React from 'react';
import '../styles/PageLoader.css';

interface PageLoaderProps {
  isLoading: boolean;
  message?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ isLoading, message = 'Processing...' }) => {
  if (!isLoading) return null;

  return (
    <div className="page-loader-overlay">
      <div className="page-loader-content">
        <div className="page-loader-spinner"></div>
        <p className="page-loader-message">{message}</p>
      </div>
    </div>
  );
};

export default PageLoader;